<template>
  <div class="p-6 md:p-10">
    <p class="text-xs uppercase tracking-[0.4em] text-amber-500 font-semibold">Account</p>
    <h1 class="mt-2 text-3xl font-bold text-gray-900">Change Password</h1>
    <p class="mt-2 text-gray-600">Update the password used to sign in to this admin panel.</p>

    <div v-if="isDemo" class="mt-6 max-w-md rounded-2xl border border-amber-200 bg-amber-50 px-5 py-4 text-sm text-amber-800 leading-relaxed">
      Firebase isn't connected yet, so this admin login isn't a real account and its password can't be changed here.
      Once Firebase credentials are added, you'll be able to change your real password from this page.
    </div>

    <form v-else @submit.prevent="handleSubmit" class="mt-8 max-w-md space-y-4">
      <div>
        <label class="text-xs uppercase tracking-wide text-gray-500">Old Password</label>
        <input
          v-model="oldPassword"
          type="password"
          required
          class="mt-2 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-amber-500"
        />
      </div>
      <div>
        <label class="text-xs uppercase tracking-wide text-gray-500">New Password</label>
        <input
          v-model="newPassword"
          type="password"
          required
          minlength="6"
          class="mt-2 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-amber-500"
        />
        <p class="mt-1 text-xs text-gray-400">At least 6 characters.</p>
      </div>
      <div>
        <label class="text-xs uppercase tracking-wide text-gray-500">Confirm New Password</label>
        <input
          v-model="confirmPassword"
          type="password"
          required
          minlength="6"
          class="mt-2 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-amber-500"
        />
      </div>

      <p v-if="error" class="text-sm text-red-500">{{ error }}</p>
      <p v-if="success" class="rounded-2xl border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-700">{{ success }}</p>

      <button
        type="submit"
        :disabled="submitting"
        class="rounded-2xl bg-amber-500 px-6 py-3 text-sm font-semibold uppercase tracking-wide text-white transition hover:bg-amber-600 disabled:opacity-60"
      >
        {{ submitting ? 'Updating...' : 'Update Password' }}
      </button>
    </form>
  </div>
</template>

<script>
import { changePassword, isUsingDemoAuth } from '../../services/authStore'

export default {
  name: 'AdminChangePassword',
  data() {
    return {
      isDemo: isUsingDemoAuth(),
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      error: '',
      success: '',
      submitting: false
    }
  },
  methods: {
    async handleSubmit() {
      this.error = ''
      this.success = ''

      if (this.newPassword !== this.confirmPassword) {
        this.error = 'New password and confirmation do not match.'
        return
      }
      if (this.newPassword.length < 6) {
        this.error = 'New password must be at least 6 characters.'
        return
      }

      this.submitting = true
      try {
        await changePassword(this.oldPassword, this.newPassword)
        this.success = 'Password updated successfully.'
        this.oldPassword = ''
        this.newPassword = ''
        this.confirmPassword = ''
      } catch (e) {
        this.error = e.message || 'Something went wrong. Please try again.'
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
